import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/user/account.service';
import { Subscription, Subject } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from 'rxjs/operators';
@Component({
  selector: 'app-city-list',
  templateUrl: './city-list.component.html',
  styleUrls: ['./city-list.component.scss'],
})
export class CityListComponent implements OnInit, OnDestroy {
  @ViewChild('citySearch', { static: false }) searchbar: IonSearchbar;
  public cityList: any;
  public noData: number;
  public currentHeaderData: any = {
    modalSlotEnd: true,
    marl20: true,
    title: 'Search City',
  };

  constructor(
    private modalController: ModalController,
    private accountService: AccountService,
    private analyticsService: AnalyticsService
  ) {
    this.noData = 0;
    this.cityList = [];
  }

  selectCity(city) {
    this.modalController.dismiss({
      city,
    });
  }

  closeModal() {
    this.analyticsService.trackUnified('city_list_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Close City List',
      component: 'city-list-component',
      button: 'close-city-list-button',
    });
    this.modalController.dismiss();
  }

  private citySearchSubscription: Subscription | null = null;
  private searchSubject = new Subject<string>();

  ngOnInit() {
    this.citySearchSubscription = this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        map((term: string) => term.trim()),
        switchMap((searchTerm: string) => {
          this.cityList = [];
          this.noData = 0;
          return this.accountService.searchCity(searchTerm, 0);
        })
      )
      .subscribe((response) => {
        this.cityList = response;
      },(error) => {
        this.analyticsService.trackError(error);
      });
  }

  filterCityList(event) {
    const searchTerm = event.srcElement.value;
    this.searchSubject.next(searchTerm);
  }

  filterCityListOnEnter(event) {
    const searchTerm = event.srcElement.value;
    this.cityList = [];
    this.noData = 0;
    this.searchSubject.next(searchTerm);
  }

  ngOnDestroy() {
    this.searchSubject.complete();
    if (this.citySearchSubscription) {
      this.citySearchSubscription.unsubscribe();
    }
  }

  ionViewDidEnter(): void {
    try {
      this.searchbar?.setFocus();
    } catch (e) {}
  }
}
